/**
 * Authenticated app shell: desktop sidebar + responsive navbar (mobile ⋮ drawer).
 * Wraps all private dashboard routes.
 */
import { useEffect, useState } from "react";
import Sidebar from "../../components/dashboard/Sidebar/Sidebar";
import Navbar from "../../components/dashboard/Navbar/Navbar";
import LiveInsight from "../../components/dashboard/LiveInsight/LiveInsight";

export default function DashboardLayout({ children }) {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", JSON.stringify(isCollapsed));
  }, [isCollapsed]);

  return (
    <div className="flex min-h-screen w-full overflow-x-hidden bg-slate-50 font-sans text-slate-900 antialiased">
      <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      <div
        className={`ml-0 flex min-h-screen min-w-0 flex-1 flex-col transition-[margin] duration-300 ease-out ${
          isCollapsed ? "md:ml-[80px]" : "md:ml-[260px]"
        }`}
      >
        <Navbar />
        <main className="mx-auto w-full max-w-[1400px] flex-1 min-w-0 px-4 py-4 sm:px-5 md:px-6 md:py-6 lg:px-8">
          {children}
        </main>
      </div>
      <LiveInsight />
    </div>
  );
}
